import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HeaderLogo } from "./header-logo";
import styles from "./header.module.css";
import { HEADER_ITEMS } from "../../constants";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleScrollClick = (e, href) => {
    e.preventDefault();

    if (href === '#club' && location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsMenuOpen(false);
      return;
    }

    // Если ссылка на якорь и мы не на главной, переходим на главную с якорем
    if (href === '#club' && location.pathname !== '/') {
      window.location.href = '/';
      return;
    }

    if (href.startsWith('#') && location.pathname !== '/') {
      window.location.href = `/${href}`;
      return;
    }

    const id = href.startsWith('#') ? href.slice(1) : href;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className={styles.headerContainer}>
        <Link to="/" className={styles.headerLogoLink}>
            <div className={styles.logo}>
              <HeaderLogo />
            </div>
            <div className={styles.nameContainer}>
              <h1
                className={styles.name}
              >
                Нормальный книжный клуб
              </h1>
              <span className={styles.prof}>Мария Бурлакова</span>
            </div>
          </Link>
        <button
          className={`${styles.burgerButton} ${isMenuOpen ? styles.active : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={styles.burgerLine}></span>
          <span className={styles.burgerLine}></span>
          <span className={styles.burgerLine}></span>
        </button>
        <nav
          className={`${styles.headerCentralPart} ${isMenuOpen ? styles.mobileOpen : ""}`}
        >
          {HEADER_ITEMS.map((item) => {
            const isMentorLink = item.href === "/mentor";
            if (isMentorLink) {
              return (
                <Link
                  key={item.href}
                  to="/mentor"
                  className={styles.itemCentralPart}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              );
            }
            return (
              <a
                key={item.href}
                className={styles.itemCentralPart}
                href={item.href}
                onClick={(e) => handleScrollClick(e, item.href)}
              >
                {item.label}
              </a>
            );
          })}
        </nav>
        
      </div>
      {isMenuOpen && (
        <div
          className={styles.overlay}
          onClick={toggleMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};
